import styled from "styled-components"

export const ImageCover = styled.div`
    width: 100%;
    height: 100%;
    background-color: ${props => props.coverColour};
    opacity: ${props => props.opacity};
    position: absolute;
    z-index: 10;
`